import { RegionShared } from "@1games-ru/region-shared";
import { useEffect } from "react";
import rpc from "@1games-ru/rage-rpc";
import useGetInventory from "@/domains/inventory/hooks/useGetInventory";

export default function useUpdateInventory() {
  const { getInventory } = useGetInventory();

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Inventory.Updated,
      async (data: typeof RegionShared.Cef.Requests.ShowInventoryRequest) => {
        const { inventoryOwnerId, inventoryOwnerType } = data;

        getInventory({
          inventoryOwnerId,
          inventoryOwnerType,
        });

        return true;
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Inventory.Updated);
    };
  }, []);
}
